import { Divider, Drawer, List } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { APP_VERSION } from "../../constants";
import { selectIsLogin } from "../../features/authentication/services";
import { ProjectList } from "../../features/projects/components/ProjectList";
import { INavItem } from "../../types/interfaces";
import classes from "./Sidebar.module.scss";
import SidebarMenuItem from "./SidebarMenuItem";

interface IProps {
    drawerWidth: number;
    navItems: INavItem[];
    mobileOpen: boolean;
    handleDrawerToggle: () => void;
    handleVideoToggle: () => void;
}

const Sidebar = ({ navItems, drawerWidth, mobileOpen, handleDrawerToggle, handleVideoToggle }: IProps) => {
    const { t } = useTranslation();
    const isLogin = useSelector(selectIsLogin);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth;
            setWindowWidth(newWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [handleDrawerToggle, windowWidth]);

    const DrawerContent = () => {
        return (
            <div id='sidebar-firstChild' className={classes.drawerContent}>
                <div className={classes.navWrapper}>
                    <List>
                        {navItems.map((listItem) => {
                            return <SidebarMenuItem listItem={listItem} key={listItem.href} />;
                        })}
                    </List>
                </div>
                {isLogin && (
                    <div className={classes.projectsNav}>
                        <div className={classes.navContent}>
                            <div className={classes.headingText}>{t("COMMON.MY_PROJECTS")}</div>
                            <div className={classes.versionText}>{APP_VERSION}</div>
                            <Divider sx={{ mt: 1 }} />
                            <ProjectList handleVideoToggle={handleVideoToggle} />
                        </div>
                    </div>
                )}
            </div>
        );
    };
    return (
        <>
            {windowWidth < 900 && (
                <Drawer
                    variant='temporary'
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: false,
                    }}
                    sx={{
                        display: { xs: "block", md: "block" },
                        marginTop: { xs: "56px", md: "6rem" },
                    }}
                >
                    <DrawerContent />
                </Drawer>
            )}
            {mobileOpen && (
                <Drawer
                    variant='permanent'
                    sx={{
                        width: drawerWidth,
                        display: { xs: "none", md: "block" },
                        marginTop: { xs: "0", md: "6rem" },
                    }}
                    open
                >
                    <DrawerContent />
                </Drawer>
            )}
        </>
    );
};

export default Sidebar;
